import type { Environment } from './types';

// 测试环境配置
const testEnvironment: Environment = {
  featureTag: '',
  AMSCashierPaymentEnvironment: 'sandbox',
  officialWebsite: 'https://groupbuyth-test.front.office.groupbuyth.com',
  // 测试环境：30天
  serviceRatingTimeLimit: 30 * 24 * 60 * 60 * 1000,
  h5Url: 'https://groupbuyth-test.front.office.groupbuyth.com',
};

export default testEnvironment;
